var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formData.project_meeting &&
    _vm.formData.project_meeting.process_result === "1" &&
    _vm.formData.type.includes("2") &&
    [300, 450, 500, 550, 600].includes(
      Number(_vm.formData.items.bidding_support.task_status)
    )
    ? _c(
        "div",
        {
          staticClass: "sub-form-container",
          class: {
            "sub-form-editing": _vm.isEditingTask("bidOpeningDelivery"),
          },
        },
        [
          _c("div", { staticClass: "sub-form-title" }, [
            _vm._v("开标&交付信息"),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "is-required",
                      attrs: {
                        label: "开标结果",
                        prop: "items.bidding_support.task_status",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            disabled:
                              _vm.isViewTaskDisabled("bidOpeningDelivery"),
                          },
                          on: { change: _vm.changeBiddingResult },
                          model: {
                            value:
                              _vm.formData.items.bidding_support.task_status,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.bidding_support,
                                "task_status",
                                $$v
                              )
                            },
                            expression:
                              "formData.items.bidding_support.task_status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "450" } }, [
                            _vm._v("已开标未出结果"),
                          ]),
                          _c("el-radio", { attrs: { label: "500" } }, [
                            _vm._v("未中标"),
                          ]),
                          _c("el-radio", { attrs: { label: "550" } }, [
                            _vm._v("已中标"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.items.bidding_support.task_status === "500"
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          attrs: {
                            label: "优联未中标原因",
                            prop: "items.bidding_support.reason",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.isViewTaskDisabled("bidOpeningDelivery"),
                              },
                              model: {
                                value:
                                  _vm.formData.items.bidding_support.reason,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.bidding_support,
                                    "reason",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.bidding_support.reason",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("被废标"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("未中标"),
                              ]),
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v("流标"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "供应商参标情况",
                        prop: "items.bidding_support.supplier",
                      },
                    },
                    [
                      _vm._l(
                        _vm.formData.items.bidding_support.supplier,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "bidding-supplier-item",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "bidding-supplier-row" },
                                [
                                  index === 0
                                    ? _c("el-input", {
                                        staticClass: "bidding-supplier-name",
                                        attrs: {
                                          maxlength: 50,
                                          disabled: "",
                                          placeholder: "供应商名称",
                                        },
                                        model: {
                                          value: item.company_name,
                                          callback: function ($$v) {
                                            _vm.$set(item, "company_name", $$v)
                                          },
                                          expression: "item.company_name",
                                        },
                                      })
                                    : _c(
                                        "el-select",
                                        {
                                          staticClass: "bidding-supplier-name",
                                          attrs: {
                                            disabled:
                                              _vm.isViewTaskDisabled(
                                                "bidOpeningDelivery"
                                              ),
                                            remote: "",
                                            filterable: "",
                                            clearable: "",
                                            "remote-method": function (
                                              keyword
                                            ) {
                                              return _vm.searchSupplierOptions(
                                                keyword,
                                                item
                                              )
                                            },
                                            placeholder: "请输入供应商名称",
                                          },
                                          on: {
                                            change: function (id) {
                                              return _vm.changeSupplierOption(
                                                item,
                                                id
                                              )
                                            },
                                            "visible-change": function (
                                              visible
                                            ) {
                                              return _vm.handleSupplierVisible(
                                                visible,
                                                item
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.customer_id,
                                            callback: function ($$v) {
                                              _vm.$set(item, "customer_id", $$v)
                                            },
                                            expression: "item.customer_id",
                                          },
                                        },
                                        _vm._l(
                                          item.options || [],
                                          function (option) {
                                            return _c("el-option", {
                                              key: option.id,
                                              attrs: {
                                                label: option.company_name,
                                                value: option.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                  _c("el-input", {
                                    staticClass: "bidding-supplier-price",
                                    attrs: {
                                      maxlength: 50,
                                      readonly:
                                        _vm.isViewTaskDisabled(
                                          "bidOpeningDelivery"
                                        ),
                                      placeholder: "报价",
                                    },
                                    model: {
                                      value: item.price,
                                      callback: function ($$v) {
                                        _vm.$set(item, "price", $$v)
                                      },
                                      expression: "item.price",
                                    },
                                  }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        value: item.is_win,
                                        disabled:
                                          _vm.isViewTaskDisabled(
                                            "bidOpeningDelivery"
                                          ) || _vm.isBiddingWinDisabled(index),
                                      },
                                      on: {
                                        change: function (val) {
                                          return (item.is_win = val)
                                        },
                                      },
                                    },
                                    [_vm._v("中标")]
                                  ),
                                  index > 0 &&
                                  !_vm.isViewTaskDisabled("bidOpeningDelivery")
                                    ? _c("el-button", {
                                        staticClass: "project-info-action",
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeBiddingSupplier(
                                              index
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              index > 0 &&
                              !item.customer_id &&
                              item.company_name
                                ? _c(
                                    "div",
                                    { staticClass: "deal-supplier-unmatched" },
                                    [
                                      _vm._v(
                                        " 未匹配到供应商，请修改。旧数据：" +
                                          _vm._s(item.company_name) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                      _vm.formData.items.bidding_support.supplier.length < 20 &&
                      !_vm.isViewTaskDisabled("bidOpeningDelivery")
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "project-info-action",
                                  attrs: { type: "text" },
                                  on: { click: _vm.addBiddingSupplier },
                                },
                                [_vm._v("添加")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "中标公告" } }, [
                    _c(
                      "div",
                      { staticStyle: { width: "500px" } },
                      [
                        _c("uploadFile", {
                          ref: "biddingAnnouncementUpload",
                          attrs: {
                            "file-list":
                              _vm.formData.items.bidding_support.announcement,
                            limit: 9,
                            multiple: true,
                            disabled:
                              _vm.isViewTaskDisabled("bidOpeningDelivery"),
                            "current-file-count":
                              _vm.formData.items.bidding_support.announcement
                                .length,
                            source: "file",
                            "only-img": false,
                            "link-url": {
                              config:
                                "/user/project-delivery-file/upload/config",
                              extensions:
                                "/user/project-delivery-file/upload/file-allow-extensions",
                            },
                          },
                          on: {
                            emitUploadFile:
                              _vm.handleBiddingAnnouncementUploaded,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.formData.items.bidding_support.announcement.length
                      ? _c(
                          "div",
                          { staticClass: "file-list" },
                          _vm._l(
                            _vm.formData.items.bidding_support.announcement,
                            function (item, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "file-item",
                                  staticStyle: { width: "100%" },
                                },
                                [
                                  _vm.isImageFile(item)
                                    ? [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "120px",
                                            height: "80px",
                                            "flex-shrink": "0",
                                            border: "1px solid #ebeef5",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: _vm.$ossurl + item.url,
                                            fit: "contain",
                                            "preview-src-list":
                                              _vm.biddingAnnouncementImageSrcList,
                                          },
                                        }),
                                      ]
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "file-name",
                                          class: {
                                            "pdf-file": _vm.isPdfFile(item),
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.isPdfFile(item) &&
                                                _vm.openPdfFile(item)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.file_name))]
                                      ),
                                  !_vm.isViewTaskDisabled("bidOpeningDelivery")
                                    ? _c("el-button", {
                                        staticClass: "project-info-action",
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteBiddingAnnouncement(
                                              idx
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-download",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downProjectFile(
                                          item.url,
                                          item.file_name
                                        )
                                      },
                                    },
                                  }),
                                ],
                                2
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开标备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          maxlength: 2000,
                          "show-word-limit": "",
                          readonly:
                            _vm.isViewTaskDisabled("bidOpeningDelivery"),
                          placeholder: "请输入",
                        },
                        model: {
                          value:
                            _vm.formData.items.bidding_support
                              .bid_opening_remarks,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.bidding_support,
                              "bid_opening_remarks",
                              $$v
                            )
                          },
                          expression:
                            "formData.items.bidding_support.bid_opening_remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _vm.formData.items.bidding_support.task_status === "550"
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          attrs: {
                            label: "交付结果",
                            prop: "items.bidding_support.delivery_status",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled:
                                  _vm.isViewTaskDisabled("bidOpeningDelivery"),
                              },
                              on: { change: _vm.changeDeliveryResult },
                              model: {
                                value:
                                  _vm.formData.items.bidding_support
                                    .delivery_status,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.bidding_support,
                                    "delivery_status",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.bidding_support.delivery_status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "550" } }, [
                                _vm._v("未交付"),
                              ]),
                              _c("el-radio", { attrs: { label: "600" } }, [
                                _vm._v("已交付"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _vm.formData.items.bidding_support.task_status === "550"
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "交付备注" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              maxlength: 2000,
                              "show-word-limit": "",
                              readonly:
                                _vm.isViewTaskDisabled("bidOpeningDelivery"),
                              placeholder: "请输入",
                            },
                            model: {
                              value:
                                _vm.formData.items.bidding_support
                                  .delivery_remarks,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.items.bidding_support,
                                  "delivery_remarks",
                                  $$v
                                )
                              },
                              expression:
                                "formData.items.bidding_support.delivery_remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.showProjectInfoEditButton("bidOpeningDelivery")
            ? _c("section-edit-actions", {
                attrs: {
                  editing: _vm.isEditingTask("bidOpeningDelivery"),
                  loading: _vm.editSaving,
                },
                on: {
                  start: function ($event) {
                    return _vm.startProjectInfoEdit("bidOpeningDelivery")
                  },
                  confirm: _vm.confirmProjectInfoEdit,
                  cancel: _vm.cancelProjectInfoEdit,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }